"use client";

import { createContext, useContext } from "react";

export const BackToTopContext = createContext<{ show: boolean } | null>(null);

export function useBackToTopContext() {
	const context = useContext(BackToTopContext);

	if (!context) {
		throw new Error("useBackToTopContext must be used within a BackToTopContext");
	}

	return context;
}
